import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ChartService {

    constructor(private http: HttpClient) {
    }

    // dailyForecast(): Observable<any>  {
    //   return this.http.get("http://samples.openweathermap.org/data/2.5/history/city?q=Warren,OH&appid=b6907d289e10d714a6e88b30761fae22")
    //     .map(result => result);
    // }

    dailyForecast(): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET',
        });
        return this.http.get('http://samples.openweathermap.org/data/2.5/history/city?q=Warren,OH&appid=b6907d289e10d714a6e88b30761fae22', {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }
}
